import { useState, useEffect } from "react";
import usePropFormatter from "../utils/usepropformatter";

export default function FileUpload(props) {
  const { _props } = usePropFormatter(props.block);

  return (
    <div
      ref={props.editorRef}
      style={{
        position: "relative",
        visibility: props.block.hidden ? "hidden" : "unset",
        boxShadow: props.block.props.boxShadow,
        flexGrow: props.block.props.flexGrow,
        backgroundColor: props.block.props.backgroundColor,
        ...props.block.props.size,
        ...props.block.props.border,
        ...props.block.props.spacing,
        ...props.block.props.textStyle,
      }}
    >
      {_props && _props.placeholder}
    </div>
  );
}
